import { authHeaders } from "../../../mainApiRoutes/nonce";

export const CURRENT_URL = `${window.location.protocol}//${window.location.host}`;
export const API_URL = `${CURRENT_URL}/wp-json/tmt-insurance/v1`;

const entriesUrl = `${API_URL}/entries`;

export const getEntries = async (
  page = 1,
  perPage = 200,
  filter = "all",
  search = ""
) => {
  const url =
    `${entriesUrl}?page=${page}&per_page=${perPage}&filter=${filter}` +
    `&search=${encodeURIComponent(search)}`;
  const response = await fetch(url, { headers: authHeaders() });

  if (!response.ok) {
    throw new Error(`Response status: ${response.status}`);
  }

  return response.json();
};

export const getCounts = async () => {
  const response = await fetch(`${entriesUrl}/counts`, {
    headers: authHeaders(),
  });

  if (!response.ok) {
    throw new Error(`Response status: ${response.status}`);
  }

  return response.json();
};

/**
 * Register and email one batch. Kept small so a run never hits a PHP timeout.
 */
export const processEntries = async (entryIds, resend = false) => {
  const response = await fetch(`${entriesUrl}/process`, {
    method: "POST",
    headers: authHeaders({ "Content-Type": "application/json" }),
    body: JSON.stringify({ entry_ids: entryIds, resend }),
  });

  if (!response.ok) {
    throw new Error(`Response status: ${response.status}`);
  }

  return response.json();
};

/**
 * Issue a new password for one registrant and email it.
 *
 * This resets their password, so the caller must confirm first.
 */
export const sendCredentials = async (entryId) => {
  const response = await fetch(`${entriesUrl}/credentials`, {
    method: "POST",
    headers: authHeaders({ "Content-Type": "application/json" }),
    body: JSON.stringify({ entry_id: entryId }),
  });

  if (!response.ok) {
    throw new Error(`Response status: ${response.status}`);
  }

  return response.json();
};

/**
 * Send credentials to a batch. The server skips anyone who already has them.
 */
export const sendCredentialsBulk = async (entryIds) => {
  const response = await fetch(`${entriesUrl}/credentials`, {
    method: "POST",
    headers: authHeaders({ "Content-Type": "application/json" }),
    body: JSON.stringify({ entry_ids: entryIds }),
  });

  if (!response.ok) {
    throw new Error(`Response status: ${response.status}`);
  }

  return response.json();
};

const eventUrl = `${API_URL}/event`;

/**
 * Read a registration by attendance code without checking it in, so the
 * confirmation dialog can show who it is first.
 */
export const getRegistration = async (code) => {
  const response = await fetch(
    `${eventUrl}/registration?code=${encodeURIComponent(code)}`,
    { headers: authHeaders() }
  );

  if (!response.ok) {
    throw new Error(`Response status: ${response.status}`);
  }

  return response.json();
};

/**
 * Mark attendance. The same endpoint the door scanner uses; `source` is what
 * tells the activity log this one was done by hand.
 */
export const checkinByCode = async (code, entryId = 0) => {
  const response = await fetch(`${eventUrl}/checkin`, {
    method: "POST",
    headers: authHeaders({ "Content-Type": "application/json" }),
    body: JSON.stringify({ code, source: "manual", entry_id: entryId }),
  });

  if (!response.ok) {
    throw new Error(`Response status: ${response.status}`);
  }

  return response.json();
};

/** Recent attendance activity, newest first. */
export const getActivity = async (limit = 50) => {
  const response = await fetch(`${entriesUrl}/activity?limit=${limit}`, {
    headers: authHeaders(),
  });

  if (!response.ok) {
    throw new Error(`Response status: ${response.status}`);
  }

  return response.json();
};
